import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { LinkableItemOption } from "web_myplann/Portfolio/Types/linkableItemOption";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const TITLE_MAX_LENGTH = 255;
export const MAX_UPLOAD_SIZE_MB = 50;
const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

const pickedFileSchema = z.object({
	file: z.instanceof(File),
	filename: z.string(),
});

export const getDocumentUploadFormSchema = (t: TranslateFunction) =>
	z.object({
		pickedFile: pickedFileSchema.nullable().transform((pickedFile, ctx) => {
			if (pickedFile === null) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: t(Resources.Form.Validations.required),
				});
				return z.NEVER;
			}
			if (pickedFile.file.size === 0) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: t(Resources.Form.Validations.fileEmpty),
				});
				return z.NEVER;
			}
			if (pickedFile.file.size > MAX_UPLOAD_SIZE_BYTES) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: t(Resources.Form.Validations.fileTooLarge, {
						maxSize: MAX_UPLOAD_SIZE_MB,
					}),
				});
				return z.NEVER;
			}
			return pickedFile;
		}),
		name: z.string().trim().max(TITLE_MAX_LENGTH),
		folder: z.string().nullable(),
		linkedItem: z.custom<LinkableItemOption>().nullable(),
	});

export type PickedFile = z.infer<typeof pickedFileSchema>;

export type DocumentUploadFormInput = z.input<
	ReturnType<typeof getDocumentUploadFormSchema>
>;
export type DocumentUploadFormOutput = z.output<
	ReturnType<typeof getDocumentUploadFormSchema>
>;
